import {
  downloadDriveSpreadsheetFile,
  isGoogleDriveConfigured,
  listDriveSpreadsheetFiles
} from '../../services/googleDrive';

export const googleDriveProvider = {
  id: 'google_drive',
  name: 'Google Drive',
  fileListTitle: 'File Excel su Google Drive',
  emptyState: 'Collega Google Drive per vedere gli ultimi file Excel disponibili.',
  connectLabel: 'Importa da Google Drive',
  loadingLabel: 'Collegamento a Drive...',
  scanningLabel: 'Scansione Google Drive in corso...',
  isConfigured: isGoogleDriveConfigured,
  requiresCredentials: false,
  notConfiguredMessage: 'Google Drive non e ancora configurato. Aggiungi REACT_APP_GOOGLE_CLIENT_ID nel file .env della app.',

  listFiles: (config, options) => listDriveSpreadsheetFiles(config, options),
  downloadFile: downloadDriveSpreadsheetFile,

  getRecentEntry: (file) => ({
    provider: 'google_drive',
    providerName: 'Google Drive',
    name: file.name,
    size: file.size,
    fileId: file.id,
    driveFileId: file.id,
    mimeType: file.mimeType,
    modifiedTime: file.modifiedTime,
    webViewLink: file.webViewLink
  }),

  getFileFromRecent: (entry) => ({
    id: entry.driveFileId || entry.fileId,
    name: entry.name,
    mimeType: entry.mimeType,
    modifiedTime: entry.modifiedTime,
    webViewLink: entry.webViewLink,
    size: entry.size
  })
};
